import React from 'react';

import { Button, Text } from '@BICE_Vida/components';

import Image from 'next/image';
import Section from '../../Section';

import styles from './BenefitsPharmacy.module.scss';

import componentsId from '../../../utils/componentsId';
import { benefitsPageTexts } from '@/utils/generalTexts';

const BenefitsPharmacy = () => {
  const handleLinkClick = (path: string) => {
    const url = process.env.assetsUrl + path;
    window.open(url, '_blank');
  };

  return (
    <Section
      id={componentsId.benefits.pharmacy.section}
      customClass={styles.benefits_pharmacy_section}
    >
      <div className={styles.benefits_pharmacy_container}>
        <div className={styles.benefits_pharmacy_texts}>
          <Text className={styles.benefits_pharmacy_title}>{benefitsPageTexts.pharmacyTitle}</Text>
          <Text className={styles.benefits_pharmacy_subtitle}>
            {benefitsPageTexts.pharmacySubtitle}
          </Text>
        </div>
        <div className={styles.benetis_pharmacy_cards_container}>
          {benefitsPageTexts.pharmacyCards.map(({ title, description, image, btn }, index) => (
            <div key={title + index} className={styles.benetis_pharmacy_card}>
              <div className={styles.benetis_pharmacy_card_image}>
                <Image src={image} width={328} height={170} alt={`img_${title}`} />
              </div>
              <div className={styles.benetis_pharmacy_card_content}>
                <Text className={styles.benetis_pharmacy_card_content_title}>{title}</Text>
                <Text className={styles.benetis_pharmacy_card_content_description}>
                  {description}
                </Text>
                {btn && (
                  <Button
                    className={styles.benetis_pharmacy_card_content_btn}
                    variant="text"
                    text={btn.text}
                    onClick={() => handleLinkClick(btn.url)}
                    icon="open_in_new"
                    iconPosition="right"
                    size="small"
                  />
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </Section>
  );
};

export default BenefitsPharmacy;
